import type { RootStateOrAny } from 'react-redux'
import { connect } from 'react-redux'

import { setTempDeliveryOptions } from 'actions/deliveries'
import tempActions from 'actions/temp'

import { DatePicker } from './DatePicker'

const mapStateToProps = (state: RootStateOrAny) => ({
  disableNewDatePicker: !state.auth.get('isAuthenticated'),
  userOrders: state.user.get('orders'),
})

const mapDispatchToProps = {
  setTempSlotId: (slotId: string) => tempActions.temp('slotId', slotId),
  handleDateChange: setTempDeliveryOptions,
}

const DatePickerContainer = connect(mapStateToProps, mapDispatchToProps)(DatePicker)

export { DatePickerContainer }
